<template>
    <div>
        <div class="pipe_num">
            <div class="pipe_num_inp">
<!--                <InputField label="缺陷名称" type="text" id="serialNum" inputDivWidth="70%"-->
<!--                            label-width="30%" :modelValue="form.serialNum" placeholder="请输入缺陷名称"-->
<!--                            @update:modelValue="(value) => handleModelValueUpdate('serialNum', value)"-->
<!--                />-->
                <SelectField label="缺陷类型" id="serialNum" placeholder="请选择缺陷类型"
                             :modelValue="form.serialNum" :options="defectTypeList" labelWidth="42%"  inputDivWidth="60%"
                             @update:modelValue="(value) => handleModelValueUpdate('serialNum', value)"
                             @change="handleDefectTypeChange"
                />
            </div>
            <div class="pipe_num_inp">
                <InputField label="距离(m)" type="text" id="distance" inputDivWidth="70%"
                            label-width="30%" :modelValue="form.distance" placeholder="请输入距离(m)"
                            @update:modelValue="(value) => handleModelValueUpdate('distance', value)"
                />
            </div>
        </div>
        <div class="pipe_num">
            <div class="pipe_num_inp">
                <InputField label="分值" type="text" id="score" inputDivWidth="70%"
                            label-width="30%" :modelValue="form.score" placeholder="请输入分值"
                            @update:modelValue="(value) => handleModelValueUpdate('score', value)"
                />
            </div>
            <div class="pipe_num_inp">
                <InputField label="等级" type="text" id="grade" inputDivWidth="70%"
                            label-width="30%" :modelValue="form.grade" placeholder="请输入等级"
                            @update:modelValue="(value) => handleModelValueUpdate('grade', value)"
                />
            </div>
        </div>
        <div class="pipe_num">
            <div class="pipe_num_inp">
                <SelectField label="缺陷名称代码" id="defectName" placeholder="请选择缺陷名称"
                             :modelValue="form.defectName" :options="defectList" labelWidth="42%"  inputDivWidth="60%"
                             @update:modelValue="(value) => handleModelValueUpdate('defectName', value)"
                />
            </div>
            <div class="pipe_num_inp">
                <InputField label="缺陷点环形位置" type="text" id="clock" inputDivWidth="70%"
                            label-width="30%" :modelValue="form.clock" placeholder="请输入缺陷点环形位置（时钟）"
                            @update:modelValue="(value) => handleModelValueUpdate('clock', value)"
                />
            </div>

        </div>
        <div class="pipe_num1">
            <div>
                <textareaField label="管道内部状况描述" type="text" id="describe" inputDivWidth="60%"
                               label-width="25%" :modelValue="form.describe" placeholder="请输入管道内部状况描述"
                               @update:modelValue="(value) => handleModelValueUpdate('describe', value)"
                />
            </div>
        </div>
        <div>
            <div style="display: flex;">
                <label class="form-label" style="width:22%;display: block;color: #94a3b8;font-size: 0.9rem;margin-right: 0.5rem;">
                    <span style="visibility: hidden;">*</span>
                    上传图片
                </label>
                <div class="image-grid">
                    <div v-for="(item,index) in fileList" :key="item.id" class="image-item">
                        <div class="image-container">
                            <img :src="item.completePath || item.url" :alt="'上传图片 ' + (index + 1)" class="uploaded-image"/>
                            <button
                                class="delete-btn"
                                @click="deleteImage(index)"
                                aria-label="删除图片"
                            >
                                ×
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tieIn-button">
            <a-space>
                <ButtonField text="关闭" @click="cancel" secondary />
                <ButtonField text="保存" primary @click="handleSubmit"/>
                <Upload :list="fileList" @change="onUpload" :title="'上传图片'"/>
            </a-space>
        </div>
    </div>
</template>

<script>
export default {
    name: "pipe_num",
    data(){
        return {
            form:{},
            fileList:[],
            defectRainStructureList:[
                { name: '(AJ)支管暗接', value: 'AJ' },{ name: '(BX)变形', value: 'BX' },{ name: '(CK)错口', value: 'CK' },{ name: '(CR)异物穿入', value: 'CR' },
                { name: '(FS)腐蚀', value: 'FS' },{ name: '(PL)破裂', value: 'PL' },{ name: '(QF)起伏', value: 'QF' },{ name: '(SL)渗漏', value: 'SL' },
                { name: '(TJ)脱节', value: 'TJ' },{ name: '(TL)接口材料脱落', value: 'TL' }
            ],
            defectRainFunctionList:[
                { name: '(CJ)沉积', value: 'CJ' },{ name: '(CQ)残墙、坝根', value: 'CQ' },{ name: '(FZ)浮渣', value: 'FZ' },{ name: '(JG)结垢', value: 'JG' },
                { name: '(SG)树根', value: 'SG' },{ name: '(ZW)障碍物', value: 'ZW' }
            ],
            defectSewageStructureList:[
                { name: '(AJ)支管暗接', value: 'AJ' },{ name: '(BX)变形', value: 'BX' },{ name: '(CK)错口', value: 'CK' },{ name: '(CR)异物穿入', value: 'CR' },
                { name: '(FS)腐蚀', value: 'FS' },{ name: '(PL)破裂', value: 'PL' },{ name: '(QF)起伏', value: 'QF' },{ name: '(SL)渗漏', value: 'SL' },
                { name: '(TJ)脱节', value: 'TJ' },{ name: '(TL)接口材料脱落', value: 'TL' }
            ],
            defectSewageFunctionList:[
                { name: '(CJ)沉积', value: 'CJ' },{ name: '(CQ)残墙、坝根', value: 'CQ' },{ name: '(FZ)浮渣', value: 'FZ' },{ name: '(JG)结垢', value: 'JG' },
                { name: '(SG)树根', value: 'SG' },{ name: '(ZW)障碍物', value: 'ZW' }
            ],
            defectTypeList:[
                {name:'结构性缺陷',value:'structure'},{name:'功能性缺陷',value:'function'},{name:'管段正常',value:'normal'}
            ],
            zcList:[{ name: '(ZC)正常', value: 'ZC' }],
            defectList:[]

        }
    },
    props:{
        tieInDetail:{
            type:Object,
            default:()=>{}
        },
        defect:{
            type:Object,
            default:()=>{}
        },
        defectPipeInfo:{
            type:Object,
            default:()=>{}
        }
    },
    mounted() {
        this.form = { ...this.$props.defectPipeInfo };
        console.log(this.form)
        const { pictureUrl,serialNum } = this.form;
        if (pictureUrl) {
            this.fileList = Array.isArray(pictureUrl)
                ? pictureUrl.map((url, index) => ({
                    url,
                    completePath: url,
                    name: index,
                    id: Date.now() + Math.random()
                }))
                : String(pictureUrl).split(';')
                    .filter(url => url.trim())
                    .map((url, index) => ({
                        url,
                        completePath: url,
                        name: index,
                        id: Date.now() + Math.random()
                    }));
        }
        if(serialNum){
            const pipeType = this.tieInDetail.pipeType;

            if (serialNum === 'structure') {
                pipeType === '污水'
                    ? this.defectList = this.defectSewageStructureList
                    : this.defectList = this.defectRainStructureList;
            } else if (serialNum === 'function') {
                pipeType === '污水'
                    ? this.defectList = this.defectSewageFunctionList
                    : this.defectList = this.defectRainFunctionList;
            } else if (serialNum === 'normal') {
                this.defectList = this.zcList;
            }
        }


    },
    methods:{
        handleDefectTypeChange(value) {
            console.log("handleDefectTypeChange::", value);
            // 根据缺陷类型更新缺陷名称代码的选项
            if (value === 'structure') {
                this.defectList = this.defectRainStructureList;
            } else if (value === 'function') {
                this.defectList = this.defectRainFunctionList;
            } else if (value === 'normal') {
                this.defectList = this.zcList;
            }
        },
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        cancel(){
            this.$emit("cancel",false)
        },
        handleSubmit(){
            this.form.code = this.defect.code;
            this.form.defectInfoId = this.defect.id;
            this.form.pictureUrl = this.fileList.map(file => file.completePath).join(';');
            console.log("handleSubmit  --  this.form :",this.form)
            if(this.form.id){
                this.$emit("update",this.form)
            }else{
                this.$emit("save",this.form)
            }
            this.$emit("cancel",false)
        },
        onUpload(fileList){
            this.fileList = fileList
        },
        deleteImage(index) {
            this.fileList = this.fileList.filter((_, i) => i !== index);
            // this.$emit('update:fileList', this.fileList);
        }
    }
}
</script>

<style scoped>
.pipe_num{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0.5rem 0;
}
.pipe_num_inp{
    width: 48%;
}
.pipe_num1{
    margin: 0.5rem 0;
}
.tieIn-button{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1rem 0;
}

.image-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
    width: 90%;
}

.image-item {
    width: calc(33.333% - 10px);
    box-sizing: border-box;
}

/* 图片容器 - 用于定位删除按钮 */
.image-container {
    position: relative;
    width: 100%;
}

.uploaded-image {
    width: 100%;
    height: 150px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #e2e8f0;
}

/* 删除按钮样式 */
.delete-btn {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #ff4d4f;
    color: white;
    border: none;
    font-size: 16px;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;
}

.delete-btn:hover {
    background-color: #d9363e;
    transform: scale(1.1);
}

@media (max-width: 768px) {
    .image-item {
        width: calc(50% - 10px);
    }
}

@media (max-width: 480px) {
    .image-item {
        width: 100%;
    }
}
</style>
